// BarChart.js
import { useState } from "react";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarChart = ({ dataList }) => {
    const months = dataList.map((item) => item.period);

    const salesData = dataList.map((item) => item.count);


    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());


    const handleBarClick = (event, elements) => {
        if (elements.length > 0) {
            const index = elements[0].index;
            setSelectedMonth(index);
        }
    };

    const backgroundColors = months.map((_, index) =>
        index === selectedMonth ? "#2C8C53" : "#D9F6E5"
    );
    const data = {
        labels: months,
        datasets: [
            {
                label: "",
                data: salesData,
                backgroundColor: backgroundColors,
                borderWidth: 1,
                borderRadius: { topLeft: 8, topRight: 8, bottomLeft: 8, bottomRight: 8 },
                barThickness: 40,
                categoryPercentage: 0.6,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { display: false }, tooltip: {
                callbacks: {
                    /* label: () => "", */
                    label: function (context) {
                        const label = context.dataset.label || '';
                        const value = context.raw; // This is your count
                        return `${label} ${value}`;
                      },
                },
            },

        },
        scales: {
            y: {
                beginAtZero: false,
                grid: { display: false }, ticks: { display: false }, border: { display: false },
            },
            x: {
                grid: { display: false }, border: { display: false },
            },
        }, onClick: (event, elements) => handleBarClick(event, elements),
        onHover: (event, elements) => {
            event.native.target.style.cursor = elements.length > 0 ? "pointer" : "default";
        },
    };

    return <Bar data={data} options={options} height={130} />;
};

export default BarChart;